import { useAtomValue } from 'jotai';
import {
  viewportAtom,
  BreakpointsState,
  BreakpointKey,
} from '../Atoms/ViewportAtoms';

export type { BreakpointsState, BreakpointKey };

const useViewports = () => {
  return useAtomValue(viewportAtom);
};

export default useViewports;
